import Axios from 'axios';
import { PageableResponse, KsSession, DataResponse } from '../models';
import { composeQuery, Query } from '../models/query';
import { LatestKsSession } from '../models/latestKsSession';

export const getKsSessions = async (...criteria: Query<KsSession>[]) => (await Axios.get<PageableResponse<KsSession>>('/v1/dashboard/ks-sessions', {
  headers: {
    'Content-Type': 'application/json',
    'Cache-Control': 'no-cache',
  },
  params: composeQuery<KsSession>(...criteria),
  data: {},
})).data;

export const getLatestSessions = async (...criteria: Query<LatestKsSession>[]) => (await Axios.get<DataResponse<LatestKsSession[]>>('/v1/latest-ks-sessions', {
  headers: {
    'Content-Type': 'application/json',
    'Cache-Control': 'no-cache',
  },
  params: composeQuery<LatestKsSession>(...criteria),
  data: {},
})).data;
